var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Switch } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import isActionAllowed from "../../../../../../../core/authorization/userPermissions";
import { REPORT_EDIT } from "../../../../../../../core/constants/permissionConstants";
import { ResponseStatusCodes } from "../../../../../../../core/constants/responseStatusCodes";
import { editTrackedItemsRoute, viewTrackedItemChartRoute, } from "../../../../../../../core/constants/routesPath";
import isEmpty from "../../../../../../../core/helpers/isEmpty";
import localize from "../../../../../../../core/utils/translation-files";
import TableActions from "../../../../../../../layout/components/customTable/tableActions";
import UseCustomPagination from "../../../../../../../layout/components/hooks/useCustomPagination";
import { notifications } from "../../../../../../../layout/components/notifications";
import { inActivateTrackedItem, activateTrackedItem, } from "../../../../../../../redux/trackedItem/actions";
import UserCreatedtrackedItemTable from "./components/userCreatedtrackedItemTable";
import usePermissions from "../../../../../../../core/hooks/usePermissions";
import { TrackedItemApi } from "../../../../../../../core/api/trackedItemApi";
import { TrackedItemsVariables } from "../../../../../../../core/constants/TrackedItemsConstants";
import IntegrationPopover from "./IntegrationPopover";
const UserCreatedTrackedItemsListingContainer = ({ filters, inActivateTrackedItem, activateTrackedItem, isSubmitAction, setIsSubmitAction, isPrintMode, isHidden, selectedTag, lastActionType, }) => {
    var _a, _b;
    const history = useHistory();
    const { isSiteAdmin } = usePermissions();
    const [trackedItems, setTrackedItems] = useState([]);
    const [totalData, setTotalData] = useState([]);
    const isFirstRender = useRef(true);
    // const searchDebounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const prevSearchValueRef = useRef("");
    const hadActiveSearchRef = useRef(false);
    const skipNextClearFetchRef = useRef(false);
    // const searchValue = useSelector(
    //   (state: RootStateOrAny) => state?.searchInput
    // );
    const queryParams = (_a = history.location.state) === null || _a === void 0 ? void 0 : _a.queryParams;
    const searchValue = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.searchInput) || "";
    const _c = UseCustomPagination({
        totalRecords: (_b = trackedItems === null || trackedItems === void 0 ? void 0 : trackedItems.length) !== null && _b !== void 0 ? _b : 0,
        clientPagination: true,
    }), { handleCustomTablePropChange } = _c, restPaginationProps = __rest(_c, ["handleCustomTablePropChange"]);
    const handleGetTrackItem = useCallback(() => {
        const { groupId, companyId, siteId } = filters;
        // setTrackedItems([]);
        if (isEmpty(siteId) && isSiteAdmin)
            return;
        if (!isEmpty(groupId)) {
            const trimmedSearch = searchValue ? searchValue.trim() : "";
            if (trimmedSearch.length < TrackedItemsVariables.MINIMUM_SEARCH_LENGTH &&
                trimmedSearch.length !== 0)
                return;
            // Determine SEARCH_TYPE and keyword based on last action
            // If both are active, use the latest one (lastActionType)
            // If one is cleared, use the remaining one
            let searchType;
            let keyword = "";
            const hasSearch = trimmedSearch.length >= TrackedItemsVariables.MINIMUM_SEARCH_LENGTH;
            const hasTag = !!selectedTag;
            if (hasSearch && hasTag) {
                // Both are active, use the latest one
                if (lastActionType === "search") {
                    searchType = "reportName";
                    keyword = trimmedSearch;
                }
                else if (lastActionType === "tag") {
                    searchType = "reportTag";
                    keyword = selectedTag;
                }
                else {
                    // No lastActionType, default to search
                    searchType = "reportName";
                    keyword = trimmedSearch;
                }
            }
            else if (hasSearch) {
                // Only search is active
                searchType = "reportName";
                keyword = trimmedSearch;
            }
            else if (hasTag) {
                // Only tag is active
                searchType = "reportTag";
                keyword = selectedTag;
            }
            // If neither is active, searchType and keyword remain undefined/empty
            const additionalParams = Object.assign(Object.assign({}, (isHidden ? { isHidden: true } : { isHidden: false })), (searchType ? { searchType: searchType } : {}));
            if (keyword || searchType) {
                console.log("Calling search endpoint with params:", Object.assign({ groupId, companyId: companyId !== null && companyId !== void 0 ? companyId : -1, siteId: siteId !== null && siteId !== void 0 ? siteId : -1, keyword, searchType: searchType }, additionalParams));
                TrackedItemApi.searchTrackedItems(groupId, companyId !== null && companyId !== void 0 ? companyId : -1, siteId !== null && siteId !== void 0 ? siteId : -1, keyword, additionalParams)
                    .then((response) => {
                    var _a, _b;
                    console.log("Search API Response:", {
                        params: {
                            groupId,
                            companyId: companyId !== null && companyId !== void 0 ? companyId : -1,
                            siteId: siteId !== null && siteId !== void 0 ? siteId : -1,
                            keyword,
                        },
                        response,
                        responseType: typeof response,
                        isArray: Array.isArray(response),
                        responseLength: Array.isArray(response)
                            ? response.length
                            : "Not an array",
                    });
                    if (!isEmpty(response)) {
                        if (Array.isArray(response) && response.length > 0) {
                            if (((_a = response[0]) === null || _a === void 0 ? void 0 : _a.data) !== undefined) {
                                setTrackedItems((_b = response[0]) === null || _b === void 0 ? void 0 : _b.data);
                                setTotalData(response[0]);
                            }
                            else {
                                setTrackedItems(response);
                                setTotalData({});
                            }
                        }
                        else if (response === null || response === void 0 ? void 0 : response.data) {
                            setTrackedItems(response.data);
                            setTotalData(response);
                        }
                        else {
                            setTrackedItems([]);
                            setTotalData([]);
                        }
                    }
                    else {
                        setTrackedItems([]);
                        setTotalData([]);
                    }
                })
                    .catch((error) => {
                    console.error("Search API Error:", error);
                });
            }
            else {
                // Use search endpoint for default fetch (no search or tag)
                const defaultParams = Object.assign({}, (isHidden ? { isHidden: true } : { isHidden: false }));
                console.log("Calling search endpoint with default params:", Object.assign({ groupId, companyId: companyId !== null && companyId !== void 0 ? companyId : -1, siteId: siteId !== null && siteId !== void 0 ? siteId : -1 }, defaultParams));
                TrackedItemApi.searchTrackedItems(groupId, companyId !== null && companyId !== void 0 ? companyId : -1, siteId !== null && siteId !== void 0 ? siteId : -1, "", defaultParams)
                    .then((response) => {
                    var _a, _b;
                    if (!isEmpty(response)) {
                        if (Array.isArray(response) && response.length > 0) {
                            if (((_a = response[0]) === null || _a === void 0 ? void 0 : _a.data) !== undefined) {
                                setTrackedItems((_b = response[0]) === null || _b === void 0 ? void 0 : _b.data);
                                setTotalData(response[0]);
                            }
                            else {
                                setTrackedItems(response);
                                setTotalData({});
                            }
                        }
                        else if (response === null || response === void 0 ? void 0 : response.data) {
                            setTrackedItems(response.data);
                            setTotalData(response);
                        }
                        else {
                            setTrackedItems([]);
                            setTotalData([]);
                        }
                    }
                    else {
                        setTrackedItems([]);
                        setTotalData([]);
                    }
                })
                    .catch((error) => {
                    console.error("Search API Error:", error);
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters, searchValue, selectedTag]);
    useEffect(() => {
        if ((isFirstRender.current || isSubmitAction) && !isEmpty(filters)) {
            handleGetTrackItem();
            skipNextClearFetchRef.current = true;
            isFirstRender.current = false;
            setIsSubmitAction(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [handleGetTrackItem, filters, isSubmitAction]);
    // useEffect(() => {
    //   if (!isEmpty(filters) && !isEmpty(filters.groupId)) {
    //     handleGetTrackItem();
    //   }
    //   // eslint-disable-next-line react-hooks-exhaustive-deps
    // }, [selectedTag]);
    useEffect(() => {
        // if (searchDebounceRef.current) {
        //   clearTimeout(searchDebounceRef.current);
        // }
        const trimmedSearch = searchValue ? searchValue.trim() : "";
        const prevTrimmedSearch = prevSearchValueRef.current;
        if (!isEmpty(filters) && !isEmpty(filters.groupId)) {
            if (trimmedSearch.length >= TrackedItemsVariables.MINIMUM_SEARCH_LENGTH) {
                // searchDebounceRef.current = setTimeout(() => {
                handleGetTrackItem();
                // }, TrackedItemsVariables.SEARCH_DEBOUNCE_TIME);
                skipNextClearFetchRef.current = false;
                hadActiveSearchRef.current = true;
            }
            else if (trimmedSearch.length === 0 &&
                (prevTrimmedSearch.length >=
                    TrackedItemsVariables.MINIMUM_SEARCH_LENGTH ||
                    hadActiveSearchRef.current)) {
                if (skipNextClearFetchRef.current) {
                    skipNextClearFetchRef.current = false;
                }
                else {
                    hadActiveSearchRef.current = false;
                    handleGetTrackItem();
                }
            }
        }
        prevSearchValueRef.current = trimmedSearch;
        // return () => {
        //   if (searchDebounceRef.current) {
        //     clearTimeout(searchDebounceRef.current);
        //   }
        // };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters, selectedTag]);
    const inActivateTrackedItemHandler = (data) => {
        inActivateTrackedItem(data).then((response) => {
            if (response &&
                response.code === ResponseStatusCodes.DATA_CONSTRAINT_VIOLATION) {
                return;
            }
            else {
                handleGetTrackItem();
                notifications.success(localize(["TrackedItem.trackeditem", "disabled", "successfully"]));
            }
        });
    };
    const activateTrackedItemHandler = (data) => {
        activateTrackedItem(data).then((response) => {
            if (response &&
                response.code === ResponseStatusCodes.DATA_CONSTRAINT_VIOLATION) {
                return;
            }
            else {
                handleGetTrackItem();
                notifications.success(localize(["TrackedItem.trackeditem", "enabled", "successfully"]));
            }
        });
    };
    const editTrackedItemRedirect = (trackedItem) => {
        history.push(editTrackedItemsRoute + trackedItem.id, {
            trackedItemId: trackedItem.id,
        });
    };
    const viewTrackedItemChart = (trackedItem) => {
        history.push(viewTrackedItemChartRoute + trackedItem.id, {
            trackedItemId: trackedItem.id,
        });
    };
    const trackedItemActions = (trackedItem) => {
        const actionArray = [
            {
                priority: 2,
                title: ["edit", "TrackedItem.trackedItem"],
                onClick: editTrackedItemRedirect.bind({}, trackedItem),
                svgIcon: "Edit",
                isAllowed: isActionAllowed([REPORT_EDIT]),
            },
            {
                priority: 1,
                title: trackedItem.disabled === true
                    ? ["unArchive", "TrackedItem.trackedItem"]
                    : ["archive", "TrackedItem.trackedItem"],
                isModal: true,
                modalTitle: [
                    "areYouSureTo",
                    `${trackedItem.disabled === true ? ["unarchive"] : ["Archive"]}`,
                    "TrackedItem.thisTrackedItem?",
                ],
                // isAllowed: isActionAllowed([REPORT_CREATION]),
                onConfirm: trackedItem.disabled === true
                    ? activateTrackedItemHandler.bind({}, trackedItem.id)
                    : inActivateTrackedItemHandler.bind({}, trackedItem.id),
                disbaled: !trackedItem.belongsToHoldingCompany,
                children: (React.createElement(Switch, { disabled: !trackedItem.belongsToHoldingCompany, checked: trackedItem.disabled === false, className: `ml-1 ${!trackedItem.belongsToHoldingCompany ? `disableSwitch` : ``}` })),
            },
            {
                priority: 3,
                title: ["view", "chart"],
                onClick: viewTrackedItemChart.bind({}, trackedItem),
                disbaled: trackedItem.disabled === true,
                svgIcon: "TrackItemChart",
                iconStyle: { color: "#EA5455" },
            },
        ];
        return React.createElement(TableActions, { actionArray: actionArray });
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "row", style: { marginBottom: "5px" } },
            React.createElement("div", { className: "col-lg-3 col-md-4" }),
            React.createElement("div", { className: "col-lg-9 col-md-8 row", style: { justifyContent: "flex-end", gap: "15px" } },
                React.createElement("div", { className: "", style: { maxWidth: "65px" } },
                    React.createElement("div", { className: "rating-lable" },
                        React.createElement("span", { className: "indicator online darkGreen" }),
                        " \u00A0",
                        " ",
                        React.createElement("span", { style: { fontWeight: "bold" } }, totalData.darkGreen))),
                React.createElement("div", { className: "", style: { maxWidth: "65px" } },
                    React.createElement("div", { className: "rating-lable" },
                        React.createElement("span", { className: "indicator online green" }),
                        " \u00A0",
                        " ",
                        React.createElement("span", { style: { fontWeight: "bold" } }, totalData.green))),
                React.createElement("div", { className: "", style: { maxWidth: "65px" } },
                    React.createElement("div", { className: "rating-lable" },
                        React.createElement("span", { className: "indicator online amber" }),
                        " \u00A0",
                        " ",
                        React.createElement("span", { style: { fontWeight: "bold" } }, totalData.amber))),
                React.createElement("div", { className: "", style: { maxWidth: "65px" } },
                    React.createElement("div", { className: "rating-lable" },
                        React.createElement("span", { className: "indicator online red" }),
                        " \u00A0",
                        " ",
                        React.createElement("span", { style: { fontWeight: "bold" } }, totalData.red))),
                React.createElement("div", { className: "", style: { maxWidth: "65px" } },
                    React.createElement("div", { className: "rating-lable" },
                        React.createElement("span", { className: "indicator online grey" }),
                        " \u00A0",
                        " ",
                        React.createElement("span", { style: { fontWeight: "bold" } }, totalData.unrateable))),
                React.createElement("div", { className: "", style: { maxWidth: "65px" } },
                    React.createElement("div", { className: "rating-lable" },
                        React.createElement("span", { className: "indicator online lightgrey" }),
                        " \u00A0",
                        " ",
                        React.createElement("span", { style: { fontWeight: "bold" } }, totalData.grey))),
                !isHidden && (React.createElement(IntegrationPopover, { data: totalData === null || totalData === void 0 ? void 0 : totalData.systemIntegrations })),
                React.createElement("div", { className: "", style: { maxWidth: "max-content" } },
                    React.createElement("div", { className: "rating-lable" },
                        React.createElement("span", { style: { fontWeight: "bold" } },
                            "Total Enabled Tracked Items : ",
                            totalData.totalEnabledReports))))),
        React.createElement(UserCreatedtrackedItemTable, { data: trackedItems, filters: filters, actions: trackedItemActions, paginationProps: restPaginationProps, currentPage: restPaginationProps.currentPage, pageSize: restPaginationProps.pageSize, handleCustomTablePropChange: handleCustomTablePropChange, paginationSection: restPaginationProps, isPrintMode: isPrintMode })));
};
function mapStateTopProps(state) {
    var _a;
    return {
        isPrintMode: (_a = state.togglePrint) === null || _a === void 0 ? void 0 : _a.status,
    };
}
const mapDispatchToProps = {
    inActivateTrackedItem,
    activateTrackedItem,
};
UserCreatedTrackedItemsListingContainer.propTypes = {};
export default connect(mapStateTopProps, mapDispatchToProps)(UserCreatedTrackedItemsListingContainer);
